import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ListOfRepairService from '../services/ListOfRepairService';

export const fetchRepairsGeneral = createAsyncThunk(
  'repairsGeneral/fetchRepairsGeneral',
  async ({ projectName, companyName }, { rejectWithValue }) => { // ← เพิ่ม companyName
    try {
      const data = await ListOfRepairService.getListOfRepairsGeneral(projectName, companyName); // ← ส่ง companyName
      console.log('Fetched repairs general:', data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const repairSlice = createSlice({
  name: 'repairsGeneral',
  initialState: { data: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRepairsGeneral.pending, (state) => { state.loading = true; })
      .addCase(fetchRepairsGeneral.fulfilled, (state, action) => { state.loading = false; state.data = action.payload; })
      .addCase(fetchRepairsGeneral.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export default repairSlice.reducer;